// SPDX-License-Identifier: GPL-3.0-or-later
// The fixed look of the boss sparks. The sparks use the shared particle pool.

import type { BurstShape } from "../vfx/particles.ts";

/** A hit: a few small red sparks that fall fast. */
export const HIT_SHAPE: BurstShape = {
  speed: 170,
  size: 7,
  endSize: 2,
  lifeMs: 380,
  gravity: 650,
  lift: 0.6,
};

/** A defeat: a flat ring of sparks that goes out and fades. It has no gravity. */
export const DEFEAT_SHAPE: BurstShape = {
  speed: 280,
  size: 9,
  endSize: 2,
  lifeMs: 700,
  gravity: 0,
  lift: 0,
};
